module.exports = __webpack_public_path__ + "static/map.8a9192c1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Logos/map.svg
// module id = 747
// module chunks = 137591856104208